import React from "react";
import ElitePassLogoFull from "../../assets/ElitePassLogoFull.png";

import styles from "./PublicNavbar.module.scss";

export default function PublicNavbar() {
  return (
    <div className={styles.navBarContainer}>
      <img className={styles.logo} src={ElitePassLogoFull} alt="PhiloTicket" />
    </div>
  );
}
